<template>
  <div>
    <vs-breadcrumb class="mb-6" :items="
   [
     {
       title: '权限',
       url: '/auth/node'
     },
     {
       title: '权限节点管理',
       active: true
     }
   ]"></vs-breadcrumb>

    <div>
      <vs-table ref="table" pagination :max-items="itemsPerPage" :data="list" :noDataText="noDataText" :stripe="true">
        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>节点名称</vs-th>
          <vs-th>层级</vs-th>
          <vs-th>状态</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td></vs-td>
              <vs-td><span class="text-bold">{{tr.name}}</span></vs-td>
              <vs-td>
                <ul class="con-s">
                  <li>
                    <div class="mb-1">{{Number(tr.status) === 1?'可用':'已禁用'}}</div>
                    <vs-switch v-model="tr.status" @input="changeSwitch(tr)" />
                  </li>
                </ul>
              </vs-td>
              <vs-td>{{tr.level}}</vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [],
        itemsPerPage: 20,
        noDataText: ''
      }
    },

    methods: {

      gotoNewData: function () {

      },


      delData: function (item) {

      },

      editData: function (item) {

        this.item = item
        this.editPopUpActive = true
      },

      changeSwitch: function (e) {
        //当前修改的item
        console.log('e:', e)
      },
    }
  }

</script>
<style scoped>

</style>
